export const VAGA = [
  "GERENTE",
  "COORDENADOR",
  "SUPERVISOR",
  "ATENDENTE",
  "VISTORIADOR_MOVEL",
  "VISTORIADOR_FIXO",
  "ANALISTA",
  "AUXILIAR_ASG",
  "OUTRO",
] as const;

export type VAGA_TYPE = (typeof VAGA)[number];
